// extracted by mini-css-extract-plugin
module.exports = {"footerComponent":"Footer_footerComponent__3Ziai","icons":"Footer_icons__2h1Kd","someLinks":"Footer_someLinks__1w-BU","desc":"Footer_desc__OU0Cm"};